<template>
  <div>
    <QuizEditorNav />
    <QuizStepper step="3" />
    <div class="container loader" v-if="quizLoading" style="margin-top: 84px;">
      <div class="progress">
        <div class="indeterminate"></div>
      </div>
    </div>
    <div class="container preview-bar" v-if="!quizLoading">
      <div class="tutorial-info">
        <div class="preview-title">{{title}}</div>
        <div class="preview-description">{{description}}</div>
      </div>
      <div class="preview-actions">
        <a class="btn btn-flat" :href="'/quizzes/describe/' +  this.$route.params.id">EDIT</a>
        <a class="btn btn-flat" :href="'/quizzes/assign/' + this.$route.params.id">ASSIGN</a>
      </div>
    </div>
    <Quiz :quizzer=quiz v-if="!quizLoading" />
  </div>
</template>

<script>
import QuizEditorNav from "@/components/QuizEditorNav";
import QuizStepper from "@/components/QuizStepper";
import Quiz from "@/containers/Quiz";
import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
//import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"

export default {
  mounted() {
    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user_org = user_attributes['custom:organization_id'];
          self.user_email = user_attributes['email'];
           if (self.id) {
            self.loadQuiz();
           }
        });
      }
    });
    var self = this;
  },
  updated() {},
  name: "Preview",
  data() {
    return {
      id: this.$route.params.id,
      quiz: {},
      processing: false,
      quizLoading: true,
      title: "Loading",
      description: "-",
      user_org: false,
      user_email: false,
    };
  },
  methods: {
    setProcessing(value) {
      this.processing = value;
    },

    loadQuiz(){
      let self = this;
      GqlV2Query.getQuiz(this.id,  (err, result) => {
        let quiz=result.data.quiz[0];
        self.quiz=quiz;
        self.originalQuiz = quiz;
        self.title=quiz.title;
        self.description=quiz.description;
        self.time_to_complete=quiz.time_to_complete;
        self.quizLoading = false;
        M.AutoInit();
        setTimeout(function() {
              if (self.description) {
                $("#description")
                  .parent()
                  .find("label")
                  .addClass("active");
                $("#description").trigger("focus");
              }
              if (self.title) {
                $("#name")
                  .parent()
                  .find("label")
                  .addClass("active");
              }
              var elems = document.querySelectorAll("select");
              var instances = M.FormSelect.init(elems);
              $("#name").focus();
            }, 200);
      });
    },

    
  },
  components: {
    Quiz,
    QuizEditorNav,
    QuizStepper
  }
};
</script>
<style scoped>
#toast-container {
  min-width: 10%;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  margin-top: -69px;
}
</style>
<style scoped>
.preview-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.preview-actions {
  text-align: right;
  flex-shrink: 0;
}
h2 {
  color: #58595b;
  font-family: Roboto;
  font-size: 24px;
  line-height: 32px;
  margin-top: 60px;
  margin-bottom: 24px;
}
button {
  margin-left: 10px;
}
.time-to-complete label {
  left: 0;
}
.right.helper-text {
  text-align: right;
}
.btn-flat {
  color: #27aae1;
}
.btn {
  font-weight: 500;
}
.btn-flat:hover {
  color: white;
  background-color: #27aae1;
}
.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
.preview-title {
  color: rgba(0,0,0,0.87);	font-family: Roboto;	font-size: 16px;	line-height: 24px;
}
.preview-description {
  color: rgba(0,0,0,0.54);	font-family: Roboto;	font-size: 14px;	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/quizzes/PreviewQuiz.vue